if (!customElements.get('sticky-atc')) {
  class StickyAtc extends HTMLElement {
    connectedCallback() {
      this.section = document.getElementById(`shopify-section-${this.dataset.section}`) || document;
      this.mainBtn = this.section.querySelector('.product-info__add-button [name="add"]');
      if (!this.mainBtn) return;

      this.bar = this.querySelector('.sticky-atc__bar');
      this.btn = this.querySelector('.js-sticky-btn');
      this.price = this.querySelector('.js-sticky-price');
      this.variantEl = this.querySelector('.js-sticky-variant');
      this.image = this.querySelector('.js-sticky-image');
      this.mainPrice = this.section.querySelector('.product-info__price');

      this.btnAbove = false;
      this.footerVisible = false;

      this.btn.addEventListener('click', this.handleClick.bind(this));
      this.section.addEventListener('on:variant:change', this.handleVariantChange.bind(this));

      // Mirror the main button text and disabled state (updated by the theme on variant change).
      this.mirror = new MutationObserver(this.syncButton.bind(this));
      this.mirror.observe(this.mainBtn, {
        attributes: true, attributeFilter: ['disabled'], childList: true, characterData: true, subtree: true
      });
      this.syncButton();
      this.syncPrice();

      this.btnObserver = new IntersectionObserver(([entry]) => {
        this.btnAbove = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        this.toggle();
      });
      this.btnObserver.observe(this.mainBtn);

      const footer = document.querySelector('footer.footer');
      if (footer) {
        this.footerObserver = new IntersectionObserver(([entry]) => {
          this.footerVisible = entry.isIntersecting;
          this.toggle();
        });
        this.footerObserver.observe(footer);
      }
    }

    disconnectedCallback() {
      if (this.mirror) this.mirror.disconnect();
      if (this.btnObserver) this.btnObserver.disconnect();
      if (this.footerObserver) this.footerObserver.disconnect();
    }

    toggle() {
      const show = this.btnAbove && !this.footerVisible;
      this.classList.toggle('is-visible', show);
      this.bar.setAttribute('aria-hidden', String(!show));
      this.btn.tabIndex = show ? 0 : -1;
    }

    syncButton() {
      this.btn.textContent = this.mainBtn.textContent.trim();
      this.btn.disabled = this.mainBtn.disabled;
    }

    syncPrice() {
      const current = this.mainPrice && this.mainPrice.querySelector('.price__current, .price__default .price__current');
      if (current && current.textContent.trim()) this.price.textContent = current.textContent.trim();
    }

    /**
     * Updates the variant title, image and price when the variant changes.
     * @param {CustomEvent} evt - on:variant:change event.
     */
    handleVariantChange(evt) {
      const variant = evt.detail && evt.detail.variant;
      if (variant) {
        if (this.variantEl && !this.variantEl.hidden) this.variantEl.textContent = variant.title;
        if (this.image && variant.featured_image) {
          const url = new URL(variant.featured_image.src, window.location.href);
          url.searchParams.set('width', '120');
          this.image.src = url.toString();
        }
      }
      setTimeout(this.syncPrice.bind(this), 50);
    }

    handleClick() {
      if (this.mainBtn.disabled) {
        this.mainBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      this.mainBtn.click();
    }
  }

  customElements.define('sticky-atc', StickyAtc);
}
